import { createStructuredSelector } from "reselect";
import {
    PR_SUPPLIER,
    PR_SUPPLIER_SUCCESS,
    PR_SUPPLIER_ERROR,
    PR_DELIVERY_ORDER,
    PR_DELIVERY_ORDER_SUCCESS,
    PR_DELIVERY_ORDER_ERROR,
    PR_LIST,
    PR_LIST_SUCCESS,
    PR_LIST_ERROR,
    PR_LIST_SEARCH_CHANGE,
    PR_LIST_PAGE_SET,
    PR_LIST_WITHOUT_PR,
    PR_LIST_WITHOUT_PR_SUCCESS,
    PR_LIST_WITHOUT_PR_ERROR,
    PR_UPLOAD_MODAL_SET,
    PR_UPLOAD_CHANGE_SET,
    PR_UPLOAD,
    PR_UPLOAD_SUCCESS,
    PR_UPLOAD_ERROR,
    PR_UPLOAD_SET,
    PR_UPLOAD_SET_SUCCESS,
    PR_UPLOAD_SET_ERROR,
    PR_UPLOAD_RESET
} from "../../actions";

export const NAME = 'paymentReceipt';

export const PRSupplier = (data) => ({
    type: PR_SUPPLIER,
    payload: data
});

export const PRSupplierSuccess = (data) => ({
    type: PR_SUPPLIER_SUCCESS,
    payload: data
});

export const PRSupplierError = (error) => ({
    type: PR_SUPPLIER_ERROR,
    payload: error
});

export const PRDeliveryOrder = (data) => ({
    type: PR_DELIVERY_ORDER,
    payload: data
});

export const PRDeliveryOrderSuccess = (data) => ({
    type: PR_DELIVERY_ORDER_SUCCESS,
    payload: data
});

export const PRDeliveryOrderError = (error) => ({
    type: PR_DELIVERY_ORDER_ERROR,
    payload: error
});

export const PRList = (page, num_page, orderBy, filters, stateFilter) => ({
    type: PR_LIST,
    payload: { page: page, num_page: num_page, orderBy: orderBy, filters: filters, filtersState: stateFilter }
});

export const PRListSuccess = (data) => ({
    type: PR_LIST_SUCCESS,
    payload: data
});

export const PRListError = (error) => ({
    type: PR_LIST_ERROR,
    payload: error
});

export const PRPageSet = (data) => ({
    type: PR_LIST_PAGE_SET,
    payload: data
});

export const PRSearchChange = (data) => ({
    type: PR_LIST_SEARCH_CHANGE,
    payload: data
});


export const PRListWithoutPR = (data) => ({
    type: PR_LIST_WITHOUT_PR,
    payload: data
});

export const PRListWithoutPRSuccess = (data) => ({
    type: PR_LIST_WITHOUT_PR_SUCCESS,
    payload: data
});

export const PRListWithoutPRError = (error) => ({
    type: PR_LIST_WITHOUT_PR_ERROR,
    payload: error
});

export const PRUploadModalSet = (data) => ({
    type: PR_UPLOAD_MODAL_SET,
    payload: data
});

export const PRUploadChangeSet = (data) => ({
    type: PR_UPLOAD_CHANGE_SET,
    payload: data
});

export const PRUpload = (page, num_page, orderBy, filters, data) => ({
    type: PR_UPLOAD,
    payload: { page: page, num_page: num_page, orderBy: orderBy, filters: filters, data: data }
});

export const PRUploadSuccess = (message) => ({
    type: PR_UPLOAD_SUCCESS,
    payload: message
});

export const PRUploadError = (error) => ({
    type: PR_UPLOAD_ERROR,
    payload: error
});


export const PRUploadSet = (file) => ({
    type: PR_UPLOAD_SET,
    payload: { file },
});

export const PRUploadSetSuccess = (items) => ({
    type: PR_UPLOAD_SET_SUCCESS,
    payload: items,
});

export const PRUploadSetError = (error) => ({
    type: PR_UPLOAD_SET_ERROR,
    payload: error,
});

export const PRUploadReset = () => ({
    type: PR_UPLOAD_RESET
});


const paymentReceipt = (state) => state[NAME];

export const PaymentReceiptSelector = createStructuredSelector({
    paymentReceipt
})